import React, { useEffect, useState } from 'react';
import SideNav from '../shared/sidenav/SideNav';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import '../oms/Oms.scss';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { fetchPurchaseRequests } from '../../redux/oms/omsActions';
import {
  selectFilteredTasks,
  selectTaskStatuses,
} from '../../redux/oms/omsSelectors';
import Options from '../oms/Options/Options';
import TaskOverview from '../TaskOverview/TaskOverview';
import { IOmsStatusTab } from '../../models/Oms';

const XetTrack: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const statuses = useSelector(selectTaskStatuses);
  const { category } = useParams();
  const filteredTasks = useSelector(selectFilteredTasks);
  const [selectedTab, setSelectedTab] = useState<IOmsStatusTab>(
    new URLSearchParams(location.search).get('status') as IOmsStatusTab
  );

  useEffect(() => {
    const queryParams = getQueryParams(location.search);
    const status = queryParams.get('status');

    // If no status is provided, redirect to the default status
    if (!status || (status !== 'ongoing' && status !== 'completed')) {
      queryParams.set('status', 'ongoing');
      navigate(`${location.pathname}?${queryParams.toString()}`, {
        replace: true,
      });
    }

    setSelectedTab(status as IOmsStatusTab);
  }, [location.search, location.pathname]);

  const getQueryParams = (search: string) => {
    return new URLSearchParams(search);
  };

  return (
    <>
      <div className="flex-row">
        <SideNav></SideNav>
        <div className="content-section flex-1 flex-column">
          <Options showStatusTabs={true} selectedTab={selectedTab} />
          <img
            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240109190634-box+1.svg"
            alt="box-background"
            className="box-background"
          />
          {filteredTasks && (
            <TaskOverview
              statuses={statuses}
              tasks={filteredTasks}
            ></TaskOverview>
          )}
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
};

export default XetTrack;
